<template>
  <div style="height: 100%">
    <v-card style="height: 100%">
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" align="center">
            <h1>Monthly Placements</h1>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col class="placements-tile-label-size" align="center">
            <h2>Placement Goal:<br>{{ placementGoalData.goal }}</h2>
          </v-col>
          <v-col class="placements-tile-label-size" align="center">
            <h2>Placements:<br>{{ placementGoalData.placementsCount }}</h2>
          </v-col>
          <v-col class="placements-tile-label-size" align="center">
            <h2>Falloff:<br>{{ placementGoalData.fallOffsCount }}</h2>
          </v-col>
          <v-col class="placements-tile-label-size" align="center">
            <h2>Net Add:<br>{{ placementGoalData.netAdd }}</h2>
          </v-col>
          <v-col class="placements-tile-label-size" align="center">
            <h2>Net Goal:<br>{{ placementGoalData.netGoal }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center" class="pt-0">
            <v-btn
              text
              color="primary"
              :disabled="disableButtons"
              @click="showPlacementGoalDetails"
            >
              Details
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="end">
            <v-btn
              v-if="!showFetchingDataGIF"
              color="primary"
              outlined
              class="ml-2"
              @click="refreshTile"
              style="float: left;"
              >
                <v-icon>refresh</v-icon>
            </v-btn>
            <i
              v-if="showFetchingDataGIF"
              class="mr-2"
            >
              Fetching Data
            </i>
            <v-progress-circular
              v-if="showFetchingDataGIF"
              :size="30"
              :width="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <i
              v-if="lastRefreshTime"
              class="ml-10 mr-5"
            >
              Last Update: {{ lastRefreshTime }}
            </i>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <DynamicModal
      :showModal="showPlacementGoalDetailsModal"
      :persistent="false"
      @clickOutside="closePlacementGoalDetails"
      title="Monthly Placements Detail"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closePlacementGoalDetails"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <PlacementGoalDetails
          :placements="placementGoalData.placements"
          :fallOffs="placementGoalData.fallOffs"
        ></PlacementGoalDetails>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <v-row>
          <v-col cols="12">
            <v-btn
              block
              depressed
              outlined
              @click="closePlacementGoalDetails"
            >
              Close
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import PlacementGoalDetails from './PlacementGoalDetails'
import { mapActions } from 'vuex'
import { isJSONString } from '@/lib/miscellaneous'
import { getLocalTimeString } from '@/lib/display'

export default {
  components: {
    DynamicModal,
    PlacementGoalDetails
  },
  data () {
    return {
      showPlacementGoalDetailsModal: false,
      placementGoalData: {
        currentMonth: 0,
        goal: 0,
        assignments: []
      },
      lastRefreshTime: null,
      showFetchingDataGIF: false,
      disableButtons: false
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getPlacementGoalCurrentMonth'
    ]),
    showPlacementGoalDetails () {
      this.showPlacementGoalDetailsModal = true
    },
    closePlacementGoalDetails () {
      this.showPlacementGoalDetailsModal = false
    },
    refreshTile () {
      this.showFetchingDataGIF = true
      this.disableButtons = true
      this.getPlacementGoalCurrentMonth().then((data) => {
        if (data) {
          let dateTimeNow = new Date()
          this.placementGoalData = data
          localStorage.setItem('dashboard:placement-goal', JSON.stringify(data))
          localStorage.setItem('dashboard:placement-goal-last-refresh-time', JSON.stringify(dateTimeNow.toUTCString()))
          this.lastRefreshTime = getLocalTimeString(dateTimeNow)
        }
        this.showFetchingDataGIF = false
        this.disableButtons = false
      })
    }
  },
  created () {
    if (localStorage.getItem('dashboard:placement-goal') && isJSONString(localStorage.getItem('dashboard:placement-goal'))) {
      this.placementGoalData = JSON.parse(localStorage.getItem('dashboard:placement-goal'))
    }
    if (localStorage.getItem('dashboard:placement-goal-last-refresh-time') && isJSONString(localStorage.getItem('dashboard:placement-goal-last-refresh-time'))) {
      let lastRefreshTime = new Date(JSON.parse(localStorage.getItem('dashboard:placement-goal-last-refresh-time')))
      this.lastRefreshTime = getLocalTimeString(lastRefreshTime)
    }
    this.refreshTile()
  }
}
</script>

<style>
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (max-width: 768px) {
  .placements-tile-label-size {
    width: 50% !important;
  }
}
@media only screen and (min-width: 768px) {
  .placements-tile-label-size {
    width: 20% !important;
  }
}
</style>
